"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DotContainer = (0, _styledComponents["default"])('div').withConfig({
  displayName: "PaginationDots__DotContainer",
  componentId: "sc-7of22f-0"
})(["display:flex;"]);
var Dot = (0, _styledComponents["default"])('button').withConfig({
  displayName: "PaginationDots__Dot",
  componentId: "sc-7of22f-1"
})(["content:'';width:12px;height:12px;border:1px solid ", ";border-radius:50%;background-color:", ";transition:background-color 0.25s ease-in-out;padding:0;&:after{content:'';position:absolute;top:0;left:0;width:100%;height:100%;cursor:pointer;}"], function (props) {
  return props.theme.colors.magic.base;
}, function (props) {
  return props.active ? props.theme.colors.magic.base : 'transparent';
});
var DotTapArea = (0, _styledComponents["default"])('div').withConfig({
  displayName: "PaginationDots__DotTapArea",
  componentId: "sc-7of22f-2"
})(["height:32px;width:32px;position:relative;display:flex;justify-content:center;align-items:center;"]);

var PaginationDots = function PaginationDots(_ref) {
  var length = _ref.length,
      activeIndex = _ref.activeIndex,
      setActiveIndex = _ref.setActiveIndex,
      resetDelay = _ref.resetDelay;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      dotsArray = _useState2[0],
      setDotsArray = _useState2[1];

  (0, _react.useEffect)(function () {
    // Update array when the number of children changes.
    setDotsArray(new Array(length).fill('_'));
  }, [length]);
  return /*#__PURE__*/_react["default"].createElement(DotContainer, null, dotsArray.length > 1 ? dotsArray.map(function (_, index) {
    return /*#__PURE__*/_react["default"].createElement(DotTapArea, {
      key: "bullet_".concat(index)
    }, /*#__PURE__*/_react["default"].createElement(Dot, {
      active: index === activeIndex,
      onClick: function onClick() {
        setActiveIndex(index);
        resetDelay();
      },
      "aria-label": "Go To Slide ".concat(index + 1)
    }));
  }) : null);
};

PaginationDots.propTypes = {
  length: _propTypes["default"].number,
  activeIndex: _propTypes["default"].number,
  setActiveIndex: _propTypes["default"].func,
  resetDelay: _propTypes["default"].func
};
var _default = PaginationDots;
exports["default"] = _default;